import React, { useEffect, useState } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import PageHeading from "../../components/pageHeading/PageHeading";

import "../../../src/jobDetail.scss";
import { Button, Form } from "react-bootstrap";

import UserImg from "../../../src/assets/images/providerProfileImg.png";

import { fetchImage, getFullName, twoDecimalPlaces } from "../../utils/common";
import ReactStars from "react-rating-stars-component";
import { setLoader } from "../../slice/commonSlice";
import { calculateTax, createJobReview } from "../../services/auth.service";
import { toast_error, toast_success } from "../../config/Constant";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import StarRating from "../../components/rating/StarRating";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlineIcon from "@rsuite/icons/InfoOutline";
const JobDetailCustomer = ({ details }) => {
  const [description, setDescription] = useState("");
  // const [calculatedData, setCalculatedData] = useState('');
  const [rating, setRating] = useState("");
  const dispatch = useDispatch();
  const [inlineItems, setInlineItems] = useState([]);
  const [policy, setPolicy] = useState();
  const [profileImage, setProfileImage] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      if (details) {
        fetchTax(
          details?.unitPrice,
          details?.durationUpdated || details?.durationExpected
        );
        setPolicy(details?.providerId?.cancellationPolicy);
      }

      if (details?.lineItemsData) {
        let inlineData = convertToKeyValuePairs(details?.lineItemsData);
        setInlineItems(inlineData);
      }

      if (details?.providerId?.profilePic) {
        try {
          const fetchedImage = await fetchImage(details.providerId.profilePic);
          setProfileImage(fetchedImage);
        } catch (error) {
          console.error("Error fetching image:", error);
        }
      } else {
        setProfileImage(UserImg);
      }
    };

    fetchData(); // Call the inner async function
  }, [details]); // Dependency array

  const fetchTax = async (unitPrice, time) => {
    let payload = {
      unitPrice: unitPrice,
      durationExpected: time,
    };
    await dispatch(setLoader(true));
    try {
      const response = await calculateTax(payload);
      await dispatch(setLoader(false));
      // if (response?.data?.status) {
      //   setCalculatedData(response.data);
      // }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let payload = {
      userType: "user",
      reviewGivenTo: details.providerId?._id,
      providerRating: rating?.toString(),
      providerReview: description,
      serviceId: details.serviceId?._id,
      jobId: details._id,
    };

    await dispatch(setLoader(true));
    try {
      const response = await createJobReview(payload);
      toast.success(response?.data?.message, toast_success);
      await dispatch(setLoader(false));
    } catch (error) {
      toast.error(error?.data?.message, toast_error);
      await dispatch(setLoader(false));
      console.error("Error data:", error);
    }
  };

  const ratingChanged = (newRating) => {
    setRating(newRating);
  };

  const fetchTotalBreakdown = () => {
    let charges = 0;
    let additionalCharges = 0;
    let taxAmount = details?.taxAmount || 0;

    if (details?.fixedPrice) {
      charges = details?.fixedPrice;
    } else if (details?.durationUpdated) {
      charges = details?.unitPrice * details?.durationUpdated;
    } else if (details?.durationExpected) {
      charges = details?.unitPrice * details?.durationExpected;
    }

    if (inlineItems?.length > 0) {
      additionalCharges = inlineItems.reduce(
        (total, item) => total + parseFloat(item?.value || 0),
        0
      );
    }

    const total = charges + additionalCharges + taxAmount;

    return {
      charges: twoDecimalPlaces(charges),
      additionalCharges: twoDecimalPlaces(additionalCharges),
      taxAmount: twoDecimalPlaces(taxAmount),
      total: twoDecimalPlaces(total),
    };
  };

  const getDuration = () => {
    if (details?.durationUpdated) {
      return `${twoDecimalPlaces(details?.durationUpdated)} Hr`;
    } else if (details?.durationExpected) {
      return `${twoDecimalPlaces(details?.durationExpected)} Hr`;
    } else {
      return "NA";
    }
  };

  function convertToKeyValuePairs(jsonString) {
    try {
      const arrayOfObjects = JSON.parse(jsonString);
      if (!Array.isArray(arrayOfObjects)) {
        console.error("Input is not an array.");
        return [];
      }
      return arrayOfObjects
        .map((obj) => {
          const keyValuePairs = Object.entries(obj);
          const mappedPairs = keyValuePairs.map(([key, value]) => {
            return { key, value };
          });
          return mappedPairs;
        })
        .flat();
    } catch (error) {
      console.error("Error parsing JSON:", error.message);
      return [];
    }
  }

  return (
    <>
      <Header />
      <PageHeading title="Job Detail" />
      <div className="main-container">
        {details ? (
          <div className="job-detail-wrapper">
            <div className="job-content-wrapper">
              <div className="job-content-section">
                <div className="box-wrapper job-content">
                  <div className="job-user-detail-wrap">
                    <div className="job-user-pic">
                      <img src={profileImage} alt="User" />
                    </div>
                    <div className="job-user-detail">
                      <div className="job-user-name">
                        {getFullName(
                          details?.providerId?.firstName,
                          details?.providerId?.lastName
                        )}
                      </div>
                      <div className="rating-wrap">
                        <div className="rating">
                          <StarRating
                            size={22}
                            rating={details?.providerId?.ratingProvider}
                          />
                        </div>
                        <div className="rating-value">
                          ({details?.providerId?.ratingProvider || 0})
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="job-descreption">{details?.jobDetail}</div>
                  {details?.quoteDescription ? (
                    <div className="job-descreption">
                      Provider description: {details?.quoteDescription}
                    </div>
                  ) : null}

                  {/* <div className='job-descreption'>Provider descreption : {details?.quoteDescription}</div> */}
                  <div className="cancellation-policy-section">
                    <div className="cancellation-policy-title">
                      Cancellation Policy :
                    </div>
                    <div className="cancellation-policy">
                      {policy == 48
                        ? "Cancel before 48 at no charge"
                        : policy == 12
                        ? "Cancel before 12 at no charge"
                        : "cancel anytime at no charge"}
                    </div>
                  </div>
                </div>
              </div>

              <div className="job-content-section">
                <div className="job-content-titile">Estimate</div>
                <div className="payment-detail-wrap">
                  <table className="table">
                    <tr>
                      <td>Time</td>
                      <td>{getDuration()}</td>
                    </tr>
                    <tr>
                      <td width="800">
                        {details?.fixedPrice != null
                          ? "Fixed Price"
                          : "Hourly Rate"}
                      </td>
                      <td width="140">
                        $
                        {details?.fixedPrice != null
                          ? details?.fixedPrice
                          : details?.unitPrice}
                      </td>
                    </tr>

                    {details?.fixedPrice == null ? (
                      <>
                        <tr>
                          <td style={{ visibility: "hidden", padding: "0px" }}>
                            $$$
                          </td>
                          <td
                            colSpan="2"
                            style={{ borderTop: "1px solid #000" }}
                          ></td>
                        </tr>
                        <tr>
                          <td style={{ visibility: "hidden", padding: "0px" }}>
                            $$$
                          </td>
                          <td>${fetchTotalBreakdown().charges}</td>
                        </tr>
                      </>
                    ) : null}

                    {inlineItems?.length > 0 && (
                      <>
                        <tr>
                          <td
                            colSpan="2"
                            style={{ borderTop: "1px solid #000" }}
                          ></td>
                        </tr>
                        <tr>
                          <td width="800" className="text-decoration-underline">
                            Additional Charges
                          </td>
                          <td width="140"></td>
                        </tr>
                        {inlineItems?.map((item, index) => (
                          <tr key={index}>
                            <td width="800">{item?.key}</td>
                            <td width="140">${item?.value}</td>
                          </tr>
                        ))}
                      </>
                    )}
                    {inlineItems?.length > 0 && (
                      <>
                        <tr>
                          <td style={{ visibility: "hidden", padding: "0px" }}>
                            $$$
                          </td>
                          <td
                            colSpan="2"
                            style={{ borderTop: "1px solid #000" }}
                          ></td>
                        </tr>
                        <tr>
                          <td
                            style={{ visibility: "hidden", paddingTop: "0px" }}
                          >
                            $$$
                          </td>
                          <td>${fetchTotalBreakdown().additionalCharges}</td>
                        </tr>
                      </>
                    )}

                    <tr>
                      <td
                        colSpan="2"
                        style={{ borderTop: "1px solid #000" }}
                      ></td>
                    </tr>

                    <tr>
                      <td width="800">Sub Total</td>
                      <td width="140">
                        $
                        {fetchTotalBreakdown().charges +
                          fetchTotalBreakdown().additionalCharges}
                      </td>
                    </tr>

                    <tr>
                      <td
                        colSpan="2"
                        style={{ borderTop: "1px solid #000" }}
                      ></td>
                    </tr>
                    <tr>
                      <Tooltip
                        title="The service fee consists of platform maintenance and bank fees required for secure payment processing."
                        place="top"
                      >
                        <InfoOutlineIcon style={{ marginLeft: "70px" }} />
                      </Tooltip>
                    </tr>

                    <tr>
                      <td>Service fee</td>

                      <td>${fetchTotalBreakdown().taxAmount}</td>
                    </tr>
                    <tr>
                      {/* <td>Total (${fetchTotalBreakdown().charges} (previous total) + ${fetchTotalBreakdown().additionalCharges}
                        (cost of additional items) + ${fetchTotalBreakdown().taxAmount} (fees) = ${fetchTotalBreakdown().total})</td> */}
                      <td>Total</td>
                      <td>
                        <div>${fetchTotalBreakdown().total}</div>
                        {/* <small>
                          (${fetchTotalBreakdown().charges} (previous total) + ${fetchTotalBreakdown().additionalCharges} 
                          (cost of additional items) + ${fetchTotalBreakdown().taxAmount} (fees) = ${fetchTotalBreakdown().total})
                        </small> */}
                      </td>
                    </tr>

                    {details?.couponCode && (
                      <>
                        <tr>
                          <td>Dicscount ({details?.couponCode})</td>
                          <td>
                            <div>${details?.couponDiscount}</div>
                          </td>
                        </tr>
                        <tr>
                          <td>New Total</td>
                          <td>
                            <div>${ twoDecimalPlaces(details?.finalPriceAfterDiscount)}</div>
                          </td>
                        </tr>
                      </>
                    )}
                  </table>
                </div>
              </div>

              {!details?.ratedByUser &&
                details?.paymentStatus === "completed" && (
                  <div className="job-content-section">
                    <div className="job-content-titile">
                      <div>Share Review</div>
                      <div className="rating">
                        <ReactStars
                          count={5}
                          onChange={ratingChanged}
                          size={24}
                          emptyIcon={<i className="far fa-star"></i>}
                          halfIcon={<i className="fa fa-star-half-alt"></i>}
                          fullIcon={<i className="fa fa-star"></i>}
                          activeColor="#ffd700"
                        />
                      </div>
                    </div>
                    <Form>
                      <Form.Group className="mb-3" controlId="description">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                          as="textarea"
                          onChange={(e) => setDescription(e.target.value)}
                          rows={3}
                          placeholder="Description"
                        />
                      </Form.Group>
                      <div className="d-grid gap-2 w-100">
                        <Button
                          variant="primary"
                          disabled={!description || !rating}
                          onClick={handleSubmit}
                        >
                          Share Review
                        </Button>
                      </div>
                    </Form>
                  </div>
                )}
            </div>
          </div>
        ) : null}
      </div>
      <Footer />
    </>
  );
};

export default JobDetailCustomer;
